import {
  LoadState,
  stateError,
  stateLoaded,
  stateLoading,
} from "@shared/models/state";
import { getTwin, TwinResponse } from "@shared/services/twinManagement";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useTwinCacheStore = defineStore("twinCache", () => {
  const twinBaseCache = ref<Map<string, LoadState<TwinResponse>>>(new Map());

  async function loadTwinBase(id: string, reload = false) {
    const current = twinBaseCache.value.get(id);
    if (reload && (current?.loaded || current?.loading)) {
      return;
    }
    twinBaseCache.value.set(id, { ...stateLoading, result: null });
    const response = await getTwin(id).catch((error) => {
      twinBaseCache.value.set(id, { ...stateError });
      throw error;
    });
    twinBaseCache.value.set(id, { ...stateLoaded, result: response.data });
  }

  return {
    twinBaseCache,
    loadTwinBase,
  };
});
